var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(-533 -1711.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customer-review",
    transform: "translate(533 1711.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M39.414,304.258H22.69L20.513,300.3a.586.586,0,0,0-1.027,0l-2.177,3.954H.586a.586.586,0,0,0-.586.586v11.133a.586.586,0,0,0,.586.586H39.414a.586.586,0,0,0,.586-.586V304.843a.586.586,0,0,0-.586-.586Zm-.586,11.133H1.172v-9.961H17.656a.586.586,0,0,0,.513-.3L20,301.8l1.83,3.325a.586.586,0,0,0,.513.3H38.828Z",
    transform: "translate(0 -276.563)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M37.447,386.964l-2.037-.3-.911-1.845a.586.586,0,0,0-1.051,0l-.911,1.845-2.037.3a.586.586,0,0,0-.325,1l1.474,1.436-.348,2.029a.586.586,0,0,0,.85.618l1.822-.958,1.822.958a.586.586,0,0,0,.85-.618L36.3,389.4l1.474-1.436a.586.586,0,0,0-.325-1Zm-2.188,1.812a.586.586,0,0,0-.169.519l.2,1.162-1.043-.549a.586.586,0,0,0-.545,0l-1.043.549.2-1.162a.586.586,0,0,0-.169-.519l-.844-.823,1.167-.17a.586.586,0,0,0,.441-.321l.522-1.057.522,1.057a.586.586,0,0,0,.441.321l1.167.17Z",
    transform: "translate(-27.656 -354.457)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M154.2,386.964l-2.037-.3-.911-1.845a.586.586,0,0,0-1.051,0l-.911,1.845-2.037.3a.586.586,0,0,0-.325,1L148.4,389.4l-.348,2.029a.586.586,0,0,0,.85.618l1.822-.958,1.822.958a.586.586,0,0,0,.85-.618l-.348-2.029,1.474-1.436a.586.586,0,0,0-.325-1Zm-2.188,1.812a.586.586,0,0,0-.169.519l.2,1.162L151,389.908a.586.586,0,0,0-.545,0l-1.043.549.2-1.162a.586.586,0,0,0-.169-.519l-.844-.823,1.167-.17a.586.586,0,0,0,.441-.321l.522-1.057.522,1.057a.586.586,0,0,0,.441.321l1.167.17Z",
    transform: "translate(-135.285 -354.457)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M263.529,387.362a.586.586,0,0,0,.148.6l1.474,1.436-.348,2.029a.586.586,0,0,0,.85.618l1.822-.958,1.822.958a.586.586,0,0,0,.85-.618L269.8,389.4l1.474-1.436a.586.586,0,0,0-.325-1l-2.037-.3L268,384.822a.586.586,0,0,0-1.051,0l-.911,1.845-2.037.3A.586.586,0,0,0,263.529,387.362Zm2.983.421a.586.586,0,0,0,.441-.321l.522-1.057.522,1.057a.586.586,0,0,0,.441.321l1.167.17-.844.823a.586.586,0,0,0-.168.519l.2,1.162-1.043-.549a.586.586,0,0,0-.545,0l-1.043.549.2-1.162a.586.586,0,0,0-.169-.519l-.844-.823Z",
    transform: "translate(-242.914 -354.456)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M381.9,389.4l-.348,2.029a.586.586,0,0,0,.85.618l1.822-.958,1.822.958a.586.586,0,0,0,.85-.618l-.348-2.029,1.474-1.436a.586.586,0,0,0-.325-1l-2.037-.3-.911-1.845a.586.586,0,0,0-1.051,0l-.911,1.845-2.037.3a.586.586,0,0,0-.325,1Zm1.361-1.617a.586.586,0,0,0,.441-.321l.522-1.057.522,1.057a.586.586,0,0,0,.441.321l1.167.17-.844.823a.586.586,0,0,0-.169.519l.2,1.162-1.043-.549a.586.586,0,0,0-.545,0l-1.043.549.2-1.162a.586.586,0,0,0-.169-.519l-.844-.823Z",
    transform: "translate(-350.543 -354.457)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M99.086,202.031h2.344a.586.586,0,0,0,0-1.172H99.7a5.281,5.281,0,0,1,5.241-4.687h11.719a5.281,5.281,0,0,1,5.241,4.688H103.773a.586.586,0,0,0,0,1.172h18.75a.586.586,0,0,0,.586-.586A6.453,6.453,0,0,0,116.664,195H104.945a6.453,6.453,0,0,0-6.445,6.445A.586.586,0,0,0,99.086,202.031Z",
    transform: "translate(-90.805 -179.766)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M173.031,14.063A7.031,7.031,0,1,0,166,7.031,7.039,7.039,0,0,0,173.031,14.063Zm0-12.891a5.859,5.859,0,1,1-5.859,5.859A5.866,5.866,0,0,1,173.031,1.172Z",
    transform: "translate(-153.031)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(14 0.4)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M7.619,41.71l-.778,1.307-1.412.435.543,3.476,3.042-.978,1.629-2.5Z",
    transform: "translate(-1.3 -9.991)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M7.619,41.71l-.778,1.307-1.412.435.543,3.476,3.042-.978,1.629-2.5Z",
    transform: "translate(7.825 -9.991)",
    fill: "#0b4475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M31.365,42.909v3.341l-1.153.8L28.406,43.59,31.365,42Z",
    transform: "translate(-6.805 -10.281)",
    fill: "#0b4475"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M-6130.813-3374.625h23.015a11.119,11.119,0,0,0-1.474-4.131,6.826,6.826,0,0,0-3.233-1.869h-13.125a6.858,6.858,0,0,0-3.661,1.623C-6130.5-3377.674-6130.813-3374.625-6130.813-3374.625Z",
    transform: "translate(6672.309 5107.979)",
    fill: "#0b4475"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExperience);
export default __webpack_public_path__ + "static/media/icon_experience.214277bbb2358366010c49e42f78bf1a.svg";
export { ForwardRef as ReactComponent };